import { useController, UseControllerProps } from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'

interface Props {
  label?: string
  placeholder?: string
  disabled?: boolean
}
export function TextAreaForm(props: Props & UseControllerProps) {
  const { control, name, label, placeholder, disabled, rules } = props
  const { fieldState } = useController(props)
  const isRequired =
    rules?.required !== undefined || rules?.validate !== undefined
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && (
            <FormLabel>
              {label}
              {isRequired && ' (*)'}
            </FormLabel>
          )}
          <FormControl>
            <Textarea
              placeholder={placeholder}
              {...field}
              disabled={disabled}
              value={field.value ?? ''}
            />
          </FormControl>
          <FormMessage>{fieldState.error?.message}</FormMessage>
        </FormItem>
      )}
    />
  )
}
